import { CommonOperationCost } from '../operation-cost'

export const CanadaOperationCost = {
  ...CommonOperationCost,
} as const
